import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { PageTransition } from './PageTransition';
// Note: Squiggle is now rendered via portal from SquiggleProvider
import styles from './MainLayout.module.scss';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  
  return (
    <div className={styles.container}>
      <div className={styles.appFrame}>
        {/* Note: Squiggle mascot is now rendered via portal from SquiggleProvider */}
        <div className={styles.content}>
          <AnimatePresence mode="wait">
            <PageTransition pageKey={location.pathname}>
              {children}
            </PageTransition>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

